/* eslint-disable react-native/no-inline-styles */
import {createDrawerNavigator} from '@react-navigation/drawer';
import React from 'react';
import {isIPad13} from 'react-device-detect';
import {DRAWER_ROUTES} from '../../navigation/constants';
import {isWebDesktopView} from '../../utils';
import DrawerContent from '../components/DrawerContent';

const Drawer = createDrawerNavigator();

const isWebDesktop = isWebDesktopView();

const Main = () => {
  return (
    <Drawer.Navigator
      drawerType={isWebDesktop ? 'permanent' : isIPad13 ? 'permanent' : 'front'}
      initialRouteName={DRAWER_ROUTES.home.path}
      drawerContent={(props) => <DrawerContent {...props} />}
      drawerStyle={{
        backgroundColor: 'transparent',
        border: 'none',
      }}>
      {Object.values(DRAWER_ROUTES).map(({component, path}) => (
        <Drawer.Screen name={path} component={component} key={path} />
      ))}
    </Drawer.Navigator>
  );
};

export default Main;
